import {ACTIONS} from './../constants';

export const addModelToCompareBucket = (model) => ({
    model,
    type: ACTIONS.ADD_MODEL_TO_COMPARE_BUCKET
});

export const removeModelFromCompareBucket = (id) => ({
    id,
    type: ACTIONS.REMOVE_MODEL_FROM_COMPARE_BUCKET
});



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/actions/index.js